import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "@mui/material";
import { FaArrowUp, FaArrowDown, FaChartBar } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import axios from "axios";
import StockLedger from "./tabs/StockLedger";
import StockAgeing from "./tabs/StockAgeing";
import StockMovement from "./tabs/StockMovement";

const StockLedgerMovement = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const location = useLocation();
  //   const [defaultPDCAccountData, setDefaultPDCAccountData] = useState([]);

  const CustomTab = ({ label, icon, ...props }) => {
    return (
      <Tab
        label={
          <span className="flex items-center space-x-2">
            <span className="text-lg transition-transform duration-200 group-hover:scale-110 group-[.Mui-selected]:scale-110 group-[.Mui-selected]:text-white">
              {icon}
            </span>
            <span className="font-semibold group-[.Mui-selected]:text-white">
              {label}
            </span>
          </span>
        }
        className={` group relative text-sm font-medium 
               transition-all duration-300 ease-in-out
               hover:text-indigo-600 hover:bg-indigo-100 hover:shadow-sm hover:scale-90 hover:rounded-md
               [&.Mui-selected]:text-white 
               [&.Mui-selected]:bg-indigo-600
               [&.Mui-selected]:border-b-4 [&.Mui-selected]:border-indigo-200
               [&.Mui-selected]:shadow-md
               [&.Mui-selected]:rounded-md
               focus:outline-none focus:ring-0 focus:ring-none focus:ring-opacity-0 text-white
               px-4 py-3 rounded-t-lg
               min-w-[120px] md:min-w-[150px]`}
        sx={{
          "&:focus": {
            zIndex: 10,
          },
        }}
        aria-label={label}
        {...props}
      />
    );
  };

  useEffect(() => {
    const tabIndexFromChild = location.state?.tabIndex;

    if (typeof tabIndexFromChild === "number") {
      setTabIndex(tabIndexFromChild);
    } else {
      setTabIndex(0);
    }

    window.history.replaceState({}, document.title);
  }, [location.state]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const issueStoreAccounts = ["1", "2", "3"];

  return (
    <div className="mx-4">
      <h2 className="text-xl text-gray-800 my-4">Stock Ledger & Movement</h2>

      <div className=" border-b  p-2">
        <div className="rounded-md">
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            className=""
            TabIndicatorProps={{
              className: "hidden",
            }}
          >
            <CustomTab label="Stock Ledger" icon={<FaArrowUp className="" />} />
            <CustomTab
              label="Stock Movement"
              icon={<FaArrowDown className="" />}
            />
            <CustomTab
              label="Stock Ageing"
              icon={<FaChartBar className="" />}
            />
          </Tabs>
        </div>
      </div>

      {/* <div className="">
        <div hidden={tabIndex !== 0}>
          <StockLedger issueStoreAccounts={issueStoreAccounts} />
        </div>
        <div hidden={tabIndex !== 1}>
          <StockMovement />
        </div>
        <div hidden={tabIndex !== 2}>
          <StockAgeing />
        </div>
      </div> */}

<div className="">
  {tabIndex === 0 && <StockLedger issueStoreAccounts={issueStoreAccounts} />}
  {tabIndex === 1 && <StockMovement />}
  {tabIndex === 2 && <StockAgeing />}
</div>

    </div>
  );
};

export default StockLedgerMovement;
